
import advancePaymentSetupImage from "~/assets/images/advance-payment-setup.svg";
import dialogCloseBtn from "../common/dialog-close-btn.vue";

export default {
  components: {
    dialogCloseBtn
  },
  props: {
    showAdvancePaymentDialog: Boolean
  },

  data() {
    return {
      advancePaymentSetupImage,
      valid: false,
      stage: 0,
      otp: "",
      otpRules: [
        v => !!v || "OTP is required",
        v => /^\d{6}$/.test(v) || "Sorry! Invalid OTP"
      ]
    };
  },
  methods: {
    submitOtp() {
      if (this.$refs.formOtp.validate()) {
        const data = {
          nextStep: "BANKING_INFO"
        };
        this.$emit("show-next-step", data);
      }
    }
  }
};
